import * as outlineIcons from '@heroicons/react/24/outline';
import { Tooltip } from '@mui/material';
import { useChatMessagesContext } from 'Context/Chat/ChatMessagesContext';
import { get } from 'lodash';
import useChatStore from 'Components/Chat/store';

const ModelButton = ({
  model,
  message,
  onClick,
  isFinished,
  isSelected,
  className = '',
  isGridView = false,
}) => {
  const isModelProviderError = useChatStore(
    (state) => state.isModelProviderError
  );

  return (
    <div
      className="flex items-center justify-between flex-wrap cursor-pointer select-none"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <div className="flex gap-1 items-center">
        {isGridView && isModelProviderError(message) && (
          <div className="flex w-[18px] h-[18px] justify-center items-center text-sm font-bold bg-brick-yellow text-white rounded-full">
            !
          </div>
        )}
        <div
          onClick={onClick}
          className={`${
            isFinished === false && 'relative animate-pulse'
          } overflow-visible w-fit capitalize rounded-md px-1 text-[12px]  ${
            isModelProviderError(message)
              ? 'bg-brick-yellow text-white'
              : isSelected
              ? 'from-white to-white via-lavender text-white bg-nue-blue'
              : 'from-ship-grey to-nue-blue via-violet-blue text-cool-gray dark:bg-tornado-cloud dark:text-powder-blue bg-platinum'
          } font-bold cursor-pointer select-none flex gap-1 items-center shadow-sm ${className} `}
        >
          <p>{model}</p>
          <CheckCapability message={message} />
        </div>
      </div>
    </div>
  );
};

const getIcon = (icon, className = 'h-6 w-6') => {
  const Icon = get(outlineIcons, icon);
  return Icon ? <Icon className={className} /> : null;
};

const CheckCapability = ({ message }) => {
  const { capabilities } = useChatMessagesContext();

  const capability = Array.isArray(capabilities)
    ? capabilities.find(
        (cap) => cap._id === message?.data?.function?.capability
      )
    : null;

  if (!message?.data?.function) {
    return;
  }

  return (
    capability && (
      <Tooltip
        title={
          <div className="p-2 text-sm leading-none text-raisin-black bg-lavender bg-opacity-25 shadow-lg text-center backdrop-filter backdrop-blur rounded-md">
            Capability:{' '}
            <span className="font-bold break-words whitespace-normal">
              {capability.name}
            </span>
          </div>
        }
      >
        {getIcon(capability.icon, 'h-4 h-4')}
      </Tooltip>
    )
  );
};

export default ModelButton;
